import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "star, favorite, award" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M7.26312 7.06162L7.53208 7.0262L7.64901 6.78142L10 1.85999L12.351 6.78142L12.4679 7.0262L12.7369 7.06162L18.1492 7.77426L14.1903 11.5282L13.9932 11.7151L14.0427 11.9821L15.0365 17.3435L10.2383 14.7422L10 14.613L9.76171 14.7422L4.96349 17.3435L5.95736 11.9821L6.00687 11.7151L5.80977 11.5282L1.85086 7.77426L7.26312 7.06162ZM9.92482 1.70259L9.92489 1.70274C9.92487 1.70269 9.92484 1.70264 9.92482 1.70259L10 1.66666L9.92482 1.70259Z",
        fill: "black",
        stroke: "#1C2026"
      })
    ], -1)
  ])))
}
export default { render: render }